module.exports = {
    "Empty": `\u{641}\u{627}\u{631}\u{63A}`
};


//# sourceMappingURL=ar-AE.main.js.map
